module.exports = __webpack_public_path__ + "static/media/扫码@3x.12287.png";